import React from 'react';
import { MOODS } from '../data/constants';
import './MoodSelector.css';

export default function MoodSelector({ selectedMoods, onMoodChange }) {
  const toggleMood = (moodId) => {
    if (selectedMoods.includes(moodId)) {
      onMoodChange(selectedMoods.filter(m => m !== moodId));
    } else {
      onMoodChange([...selectedMoods, moodId]);
    }
  };

  return (
    <div className="mood-selector">
      <h3>🎭 选择你的心情</h3>
      <div className="mood-grid">
        {MOODS.map(mood => (
          <button
            key={mood.id}
            className={`mood-btn ${selectedMoods.includes(mood.id) ? 'active' : ''}`}
            style={{
              '--mood-color': mood.color,
              borderColor: selectedMoods.includes(mood.id) ? mood.color : 'transparent',
              background: selectedMoods.includes(mood.id) ? `${mood.color}22` : 'var(--card-bg)'
            }}
            onClick={() => toggleMood(mood.id)}
          >
            <span className="mood-emoji">{mood.emoji}</span>
            <span className="mood-label">{mood.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
